import { useUserIdentityState } from '@provider/user-identity';
import { StudentHeader } from './topbar.student.js';
import { TeacherTopbar } from './topbar.teacher.js';
import { jsx } from 'react/jsx-runtime';

const topbarCls = "_275tstkj3j";
const topbarSelector = `.${topbarCls}`;
function Topbar(props) {
  const user = useUserIdentityState(state => state.user);
  return /*#__PURE__*/jsx("div", {
    className: topbarCls,
    children: user?.role === "teacher" ? /*#__PURE__*/jsx(TeacherTopbar, {
      ...props
    }) : /*#__PURE__*/jsx(StudentHeader, {
      ...props
    })
  });
}

export { Topbar, topbarSelector };
import "./topbar.linaria.module.css";
//# sourceMappingURL=topbar.js.map
